import React from "react";
import Navigation from "../components/Navigation/Navigation";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";

const Hemsidan = () => {
	return (
		<>
			{/* Navigeringsmeny inlänkad */}
			<Navigation />
			{/* Applikationens innehåll börjar */}
			<div className="main">
				<section className="wrapper">
					<h1>
						Välkommen till
						<br /> Allt om katter
					</h1>
					<br />
					<p>
						Detta är ett ställe för alla er som älskar katter. Att se en bild av en fin katt
						får många av oss att bli glada och lyckliga.
					</p>
					<p>
						På denna webbsida kan man ställa frågor, lära sig ny fakta om katter, eller bara
						njuta av de fina katterna. Har du en fin bild av din katt som du vill dela med dig
						av till andra här? Då får du gärna kontakta oss!
					</p>
					<p>
						Personligen anser jag att katten är det bästa sällskapsdjuret jag kan tänka mig.
						Katter är väldigt kelvänliga och relativt lätta att äga och bo med. Vad kan vara
						bättre än när katten hoppar upp och lägger sig till rätta i ens knä och börjar
						spinna när man sitter i tv-soffan på kvällen? Eller vad är bättre än katt som
						ligger och värmer dig i sängen när en snöstorm härjar utanför fönstret? Kanske är
						det att mötas av en katt som stryker sig mot ditt ben och "mjauar hej" på
						morgonen?
					</p>
					{/* Bildgalleri */}
					<div className="center kattkollage">
						<img
							src="./bilder/katt_mys.jpg"
							alt="Två katter som myser"
							className="responsive katt"
						/>
						<img
							src="./bilder/katt_soffa.jpg"
							alt="Katt som sover i en soffa"
							className="responsive katt"
						/>
						<img
							src="./bilder/bus_katt.jpg"
							alt="Katt som leker i en kasse"
							className="responsive katt"
						/>
						<img
							src="./bilder/katt_ansikte.jpg"
							alt="Närbild på ett kattansikte"
							className="responsive katt"
						/>
						<img
							src="./bilder/katt_boll.jpg"
							alt="Söta katt som ligger som en boll"
							className="responsive katt"
						/>
						<img src="./bilder/katter.jpg" alt="Söta kattungar" className="responsive katt" />
					</div>
					{/* Embeded YouTube-videos på sidan */}
					<Container>
						<h3>Ingen kan väl motstå dessa små sötnosar!</h3>
						<div className="ratio ratio-16x9 kattvideo">
							<iframe
								src="https://www.youtube.com/embed/Ch80pJJm50E?si=Ys3FtYk4_XRZ_zpr"
								title="YouTube video"
								allowFullScreen
							></iframe>
						</div>
						<div className="ratio ratio-16x9 kattvideo">
							<iframe
								src="https://www.youtube.com/embed/y0sF5xhGreA?si=BxKyG-bs0UpcXY3K"
								title="YouTube video"
								allowFullScreen
							></iframe>
						</div>
					</Container>
				</section>
			</div>
		</>
	);
};

export default Hemsidan;
